var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a, e_2, _b;
import { css } from "@emotion/css";
var edges = ["top", "right", "bottom", "left"];
var modes = ["padding", "margin"];
var styles = {};
try {
    for (var modes_1 = __values(modes), modes_1_1 = modes_1.next(); !modes_1_1.done; modes_1_1 = modes_1.next()) {
        var mode = modes_1_1.value;
        try {
            for (var edges_1 = (e_2 = void 0, __values(edges)), edges_1_1 = edges_1.next(); !edges_1_1.done; edges_1_1 = edges_1.next()) {
                var edge = edges_1_1.value;
                styles["".concat(mode, "-").concat(edge)] = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", "-", ": constant(safe-area-inset-", ");\n            ", "-", ": env(safe-area-inset-", ");\n        "], ["\n            ", "-", ": constant(safe-area-inset-", ");\n            ", "-", ": env(safe-area-inset-", ");\n        "])), mode, edge, edge, mode, edge, edge);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (edges_1_1 && !edges_1_1.done && (_b = edges_1.return)) _b.call(edges_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (modes_1_1 && !modes_1_1.done && (_a = modes_1.return)) _a.call(modes_1);
    }
    finally { if (e_1) throw e_1.error; }
}
export default styles;
var templateObject_1;
